import { render, staticRenderFns } from "./RiasecLegend.vue?vue&type=template&id=327e92e2&scoped=true&"
import script from "./RiasecLegend.vue?vue&type=script&lang=js&"
export * from "./RiasecLegend.vue?vue&type=script&lang=js&"
import style0 from "./RiasecLegend.vue?vue&type=style&index=0&id=327e92e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e92e2",
  null
  
)

export default component.exports